import axios from 'axios';
import {
  CREATE_CATEGORY_URL,
  ROOT_CATEGORIES_URL,
  FULL_CATEGORIES_URL,
  getCategoriesWithChildrenUrl,
  getCategoriesWithParentUrl,
  getCategoryUrl,
  getCategoriesPositionsUrl,
} from '../constants';
import { ICategoryItem } from '../pages/home/categories/interfaces';
import { IPaginationProps } from '../interfaces/server';

export function getRootCategories({
  page,
  per_page,
  parentId,
  text,
  only_active,
  with_products,
}: IPaginationProps & {
  parentId?: number;
  text?: string;
  only_active?: number;
  with_products?: number;
}) {
  if (parentId && !text) {
    return axios.get(`${getCategoriesWithChildrenUrl(parentId)}`, {
      params: { page, per_page },
    });
  }
  if (text) {
    return axios.get('/api/shop/categories/search', { params: { text } });
  }
  return axios.get(`${ROOT_CATEGORIES_URL}`, {
    params: { page, per_page, only_active, with_products },
  });
}

export function getFullCategories({
  with_products,
  company_id,
  only_active,
}: {
  with_products?: boolean;
  company_id?: number;
  only_active?: number;
}) {
  if (with_products) {
    return axios.get(`${FULL_CATEGORIES_URL}`, {
      params: { with_products: 1, company_id, only_active },
    });
  }
  return axios.get(FULL_CATEGORIES_URL);
}

export function getCategoriesWithParent({ id = 0 }) {
  return axios.get(`${getCategoriesWithParentUrl(id)}`);
}

export function getCategoryById(id: number) {
  return axios.get(`${getCategoryUrl(id)}`);
}

export function createCategory(data: ICategoryItem) {
  return axios.post(CREATE_CATEGORY_URL, data);
}

export function editCategory(id: number, data: ICategoryItem) {
  return axios.put(`${getCategoryUrl(id)}`, data);
}

export function deleteCategory(id: number | undefined) {
  return axios.delete(`${getCategoryUrl(id)}`);
}

export function setCategoriesPositions(positions: string) {
  return axios.post(getCategoriesPositionsUrl(positions));
}

export function getFavoritesCagegories() {
  return axios.get('/api/shop/categories/favorites');
}

export function getCategoryParents(id: number) {
  return axios.get(`/api/shop/category/${id}/parents`);
}

export function getCategoryChildren({
  id,
  per_page,
  page,
  only_active,
  with_products,
}: {
  id: number;
  per_page?: number;
  page?: number;
  only_active?: number;
  with_products?: number;
}) {
  return axios.get(`/api/shop/category/${id}/children`, {
    params: {
      per_page,
      page,
      only_active,
      with_products,
    },
  });
}
